import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import Navbar from '../Navegation/Dnavbar'
import Footer from '../Navegation/Footer'
import imageSrc from '../../Img/FDC.png'

function Festival(){
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    // Actualiza el ancho de la ventana cuando cambia
    useEffect(() => {
      const handleWindowResize = () => {
        setWindowWidth(window.innerWidth);
      };

      window.addEventListener('resize', handleWindowResize);

      return () => {
        window.removeEventListener('resize', handleWindowResize);
      };
    }, []);
  const main = {
    backgroundColor: '#1e1818',
    width: '100%',
    height: '90vh',
    display: 'flex',
    flexFlow: 'column',
    flexWrap: 'nowrap',
    flexDirection: 'column',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center'
  }
  const img = {
    width: windowWidth <=689 ? '40vh':'40%',
    margin: '1% 0%',
    padding: '2%'
  }
  const divBtn = {
    width: '100%',
    height: '20vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  }
  const btn = {
    width: windowWidth <= 689 ? '40vh':'80vh',
    margin: '1%'
  }

  return(
    <>
      <Navbar/>
      <div style={main}>
        <img src={imageSrc} style={img} alt="Logo festival de cortos"/>
      <div style={divBtn}>
        <Link to='https://drive.google.com/file/d/1i9oPDMI7DNtaNiyQwTT3NZgdxkmeUETd/view' target='_blank'><button type="button" class="btn btn-outline-light" style={btn}>BASES Y CONDICIONES</button></Link><br/>
        <Link to='https://docs.google.com/forms/d/e/1FAIpQLSd46mOg7FD-Ph4OGpS4OVcGrb38WBDec81aAwGEdNxIuAPmeQ/viewform' target='_blank'><button type="button" class="btn btn-outline-light" style={btn}>INSCRIPCIÓN</button></Link>
      </div>
      </div>
      <Footer/>
    </>
  )
}
export default Festival;